import { memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Button from '@UI/Button';
import styles from './NotFound.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';

export interface NotFoundProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  title?: string;
  onRepeat?: (e: MouseEvent) => void;
}

const NotFound: FC<NotFoundProps> = (props) => {
  const { className, title, onRepeat, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.text}>{t('repeat-text')}</div>
      <Button data-testid='go-again' className={styles.button} onClick={onRepeat}>
        <div className={styles.iconRefresh} />
        {t('repeat')}
      </Button>
    </div>
  );
};

export default memo(NotFound);
